import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { roleGuard } from './guards/role.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./components/home/home.component').then(m => m.HomeComponent),
    canActivate: [MsalGuard, roleGuard('calendarshare.admin')]
  },
  {
    path: 'employee-location/:id',
    loadComponent: () => import('./components/employee-location-form/employee-location-form.component').then(m => m.EmployeeLocationFormComponent),
    canActivate: [MsalGuard, roleGuard('calendarshare.admin')]
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent)
  },
  {
    path: 'login-failed',
    loadComponent: () => import('./components/login-failed/login-failed.component').then(m => m.LoginFailedComponent)
  }
];
